import { Component, OnInit,AfterViewInit ,OnDestroy,ViewChild} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as firebase from 'firebase';
import {ModalAccionesUsuarioComponent } from '../modal-acciones-usuario/modal-acciones-usuario.component'
import {ModalAccionesAutoridadComponent} from '../modal-acciones-autoridad/modal-acciones-autoridad.component'

@Component({
  selector: 'app-componente-data3',
  templateUrl: './componente-data3.component.html',
  styleUrls: ['./componente-data3.component.scss']
})
export class ComponenteData3Component implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<ComponenteData3Component> = new Subject();
  arraydeposts=[]
  arraydeempresas=[]
  trabajando=false

  nombre=''
  cedula=''
  email=''
  password=''
  dominio=''

  autoridadAislante=false
  autoridadElectrica=false
  autoridadArea=false
  autoridadAreaLocal=false
  autoridadHSE=false
  autoridadAmbiental=false
  gerenteRegional=false
  auditor=false
  regional=''


  alertaActiva=false;
  mensajeAlerta='';
  tipodeAlerta='primary';

  excelOTabla = 'tabla';
  pageSize: number = 20;
  cursor: any;
  infiniteEvent: any;
  botondisabled=true

  constructor(private modalService: NgbModal) { }


  ngOnInit(): void {
    this.inicializadatatables(()=>{
      this.query1(()=>{
        this.dtTrigger.next();
      })
      this.query2(()=>{
        
      })
    })
  }

  ngAfterViewInit(): void {
    
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {        
      // Destroy the table first
      dtInstance.destroy();
      //reload your data
      this.query1(()=>{
         // Call the dtTrigger to rerender after callback
         this.dtTrigger.next();
      })
    });
  }



inicializadatatables(callback) {
  this.dtOptions = {
    // Declare the use of the extension in the dom parameter
    dom: 'Bfrtip',
    "pageLength": 200,
    scrollX: false,
 
    // Configure the buttons
    buttons: [
      'colvis',
      'excel',
      // 'columnsToggle',
      'print'
    ]
  };
  callback()
}









  crearUsuario(){
    this.trabajando=true
    this.alerta("warning","Creando autoridad...")

    let emailcompleto=this.email+this.dominio
    console.log("emailcompleto: "+emailcompleto)
    firebase.auth().createUserWithEmailAndPassword(emailcompleto,this.password).then((data)=>{
    
      let newUser: firebase.User = data.user;
  
      //con updateprofile le agregamos al objeto data las propiedades display name y photourl que no es nada en esta app
      newUser.updateProfile({
        displayName: this.nombre
      }).then((res)=>{
            //despues de actualizar displayname incluimos el id en la base de datos de usuarios con el admin false por default
        console.log("user creado en autoridades")
        firebase.firestore().collection("autoridades").doc(data.user.uid).set({
        id: data.user.uid,
        nombre: this.nombre,
        email:newUser.email,
        autoridadAislante:this.autoridadAislante,
        autoridadElectrica:this.autoridadElectrica,
        autoridadArea:this.autoridadArea,
        autoridadAreaLocal:this.autoridadAreaLocal, 
        autoridadHSE:this.autoridadHSE,
        autoridadAmbiental:this.autoridadAmbiental,
        gerenteRegional:this.gerenteRegional,
        auditor:this.auditor,
        regional:this.regional 
        
      }).then(async(doc) => {
        console.log("user creado en users")
        firebase.firestore().collection("users").doc(data.user.uid).set({
          nombre:this.nombre,
          email:this.email,
          bloqueado:false,
          id:data.user.uid,
          empresa:this.dominio
        }).then(()=>{
           //mandamos mail de verificación
          let user = firebase.auth().currentUser;
           user.sendEmailVerification().then( ()=> {
            //sacamos una alerta.
            //  this.presentAlertConfirm();
            this.rerender()
            alert("Autoridad creada con éxito. Por favor asegúrese de activar su cuenta siguiendo el link que ha sido enviado a su mail.")
           })


      }).catch((err)=>{
        console.log(err);
      })
  
      }).catch( (error)=> {
        // An error happened.
        // this.presentAlertError(); 
      });
  
      }).catch((err)=>{ 
        console.log(err);
      })

    }).catch((err)=>{
      console.log(err);
      // this.presentAlertError(); 
      if(err.code == 'auth/email-already-in-use'){
        this.alerta("danger","Ya existe una cuenta con este email como ejecutante. Ingrese a la pestaña de Gestionar Usuarios, ubique el email del usuario y cambie su rol a Autoridad.")
      }
    });
  
  }

  validaboton(){
    console.log("validaboton activado")
      if( (this.nombre != '' && this.email !='' && this.password !='' && this.regional !='') && (this.autoridadAislante ==true || this.autoridadArea ==true || this. autoridadAreaLocal ==true|| this.autoridadHSE ==true || this.gerenteRegional ==true || this.auditor ==true || this.autoridadElectrica == true || this.autoridadAmbiental == true ) ){this.botondisabled=false}
      if  (this.nombre == '' || this.email =='' || this.password =='' || this.regional =='') {this.botondisabled=true}
      if (this.autoridadAislante ==false && this.autoridadArea ==false && this. autoridadAreaLocal ==false&& this.autoridadHSE ==false && this.gerenteRegional ==false && this.auditor ==false && this.autoridadElectrica ==false && this.autoridadAmbiental==false ){this.botondisabled=true}
  }
  

  alerta(tipo,input){
    this.alertaActiva=true;
    this.mensajeAlerta=input;
    this.tipodeAlerta=tipo;
  }


  closeAlert(){
    this.alertaActiva=false
  }


  query1(callback){
    this.arraydeposts=[];
    let query1 = firebase.firestore().collection("autoridades");
    
    query1.get().then((docs)=>{
      docs.forEach((doc)=>{
        this.arraydeposts.push(doc);
      })
    }).then(()=>{
      callback()
    }).catch((err)=>{
      console.log(err);
    })
  }

  query2(callback){
    this.arraydeempresas=[];
    let query1 = firebase.firestore().collection("empresas").orderBy("dominio","asc");
    
    query1.get().then((docs)=>{
      docs.forEach((doc)=>{
        this.arraydeempresas.push(doc);
      })
    }).then(()=>{
      callback()
    }).catch((err)=>{
      console.log(err);
    })
  }


detallesUsuario(usuario){
  const modalRef = this.modalService.open(ModalAccionesAutoridadComponent);
  modalRef.componentInstance.usuario = usuario;//pasamos al modal el parámetro de usuario

  //para recibir data desde el modal
  modalRef.result.then((result) => {
    if (result=="OK") {
    this.rerender()
    }
    });
}

//para que en el input de cedula sólo entren numeros sin comas o puntos o nada
numberOnly(event): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}


}//fin de clase
